<template>
  <div class="page">
    <list-header v-if="!isShowLeft"></list-header>
    <div class="main-panel">
      <router-view class="sub-page"></router-view>
    </div>
    <suspend-box v-if="!isShowLeft" online-icon="icon-service"></suspend-box>
  </div>
</template>

<script>
// import listHeader from '../common/navHeader.vue'
import listHeader from "../common/nextHeader.vue";
import suspendBox from "../../../../src/components/common/suspendBox.vue";
export default {
  data() {
    return {
      isFooterShow: true,
      changeRouter: false
    };
  },
  components: {
    listHeader,
    suspendBox
  },
  computed: {
     isShowLeft() {
      return this.$route.query.iframe
    }
  },
  methods: {
    getUrlIsShowFooter() {
      let url = window.location.href;
      if (url.split("/")[5] === "list") {
        this.isFooterShow = false;
      } else if (url.split("/")[4] === "homepagelist") {
        this.isFooterShow = false;
      }
    },
    udeskHandle() {
      this.$nextTick(() => {
        (function(a, h, c, b, f, g) {
          a["UdeskApiObject"] = f;
          a[f] =
            a[f] ||
            function() {
              (a[f].d = a[f].d || []).push(arguments);
            };
          g = h.createElement(c);
          g.async = 1;
          g.charset = "utf-8";
          g.src = b;
          c = h.getElementsByTagName(c)[0];
          c.parentNode.insertBefore(g, c);
        })(
          window,
          document,
          "script",
          "https://assets-cli.udesk.cn/im_client/js/udeskApi.js",
          "ud"
        );

        ud({
          code: "260bd3ji",
          link: "https://zhulogic.udesk.cn/im_client/?web_plugin_id=42958",
          mode: "inner",
          color: "#308697",
          targetSelector: "#zaixiankefu",
          //                        "targetSelector": "#color_metail_itleConenet",
          selector:
            "#color_metail_itleConenet,#aftersale_content,#shaleContent",
          noBubble: false
        });
      });
    }
  },
  mounted() {
    this.udeskHandle();
  },
  created() {
    let token = localStorage.getItem("token");
    if (token && token != "undefined") {
      this.$store.dispatch("setToken", token);
    }
  }
};
</script>
<style>
.main-panel {
  padding-top: 0px;
  background:rgba(241,241,241,1);
}
</style>